import PropTypes from 'prop-types'
import {useState, useCallback} from 'react'
import {Map} from 'immutable'

import {Cancel, Continue, ControlButton} from '../../../../../shared_components/ButtonTypes'
import Modal from '../../../../../shared_components/Modal'
import ShadowHeader from '../../shared_firm/ShadowHeader'
import ShadowWrapper from '../../shared_firm/ShadowWrapper'
import StatusToggle from '../../shared_firm/settings/StatusToggle'

import './editDeceasedAccess.scss'

const TEXTS = {
  disabled: "When a client is marked as deceased, firm users cannot see the content of that client's Everplan, regardless of their previous permissions.",
  enabled: <p>
    When a client is marked as deceased, firm users retain <strong>view</strong> access to the sections of the client's Everplan they previously had edit permission for.
  </p>
}

const EditDeceasedAccess = ({organizationConfig, processing, updateSettings}) => {
  const [showModal, setShowModal] = useState(false)
  const [enabled, setEnabled] = useState(organizationConfig.get('deceased-access', false))

  const toggleModal = useCallback(() => setShowModal(!showModal))

  const onChange = useCallback(() => setEnabled(!enabled))

  const onSubmit = useCallback(() => updateSettings({'deceased-access': enabled}, toggleModal))

  return (
    <ShadowWrapper>
      <div className='edit-deceased-access flex-container'>
        <p>Status:</p>
        <div className='details'>
          <div className='status'>
            {enabled ? 'Enabled' : 'Disabled'}
          </div>
          <div className='description'>{enabled ? TEXTS.enabled : TEXTS.disabled}</div>
          <div>
            <ControlButton faClass='fa-pencil-square-o' onClick={toggleModal} buttonText='Edit' />
            <Modal closer={toggleModal} visible={showModal}>
              <ShadowHeader headerClassName='heading' headerText='View access on deceased accounts' />
              <div className='content'>
                <StatusToggle
                  description={TEXTS}
                  enabledChecked={enabled}
                  name='cobranding'
                  onChange={onChange}
                  statusText={{
                    disabled: 'Disabled',
                    enabled: 'Enabled'
                  }}
                />
              </div>
              <div className='button-group'>
                <Cancel onClick={toggleModal} />
                <Continue loading={processing} onClick={onSubmit}>Save</Continue>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </ShadowWrapper>
  )
}

EditDeceasedAccess.propTypes = {
  organizationConfig: PropTypes.instanceOf(Map),
  processing: PropTypes.bool,
  updateSettings: PropTypes.func
}

export default EditDeceasedAccess
